import { useDispatch, useSelector } from "react-redux";
import { updateFavoriteRequest, fetchListFavoriteRequest, updateFavoriteList } from "../store/actions";
import { useCallback, useEffect } from "react";


export function useFavorite() {
  const dispatch = useDispatch();

  const handleFavorite = (data: any) => {
    dispatch(updateFavoriteRequest(data));
  }

  return { handleFavorite };
}

export function useGetListFavorite(data?: any) {
  const dispatch = useDispatch();
  const {
    loading,
    dataList,
    loadingUpdate,
    stateActive,
    lastPage,
    scrollPosition,
    params,
  } = useSelector((state: any) => state.Favorites || {});
  useEffect(() => {
    if (!dataList.length) {
      dispatch(fetchListFavoriteRequest(params));
    }
  }, [data, dispatch]);

  useEffect(() => {
    if (loadingUpdate && stateActive) {
      dispatch(fetchListFavoriteRequest(params));
    }
  }, [loadingUpdate, dispatch, data, stateActive]);

  const reLoadList = (data: any) => {
    dispatch(fetchListFavoriteRequest(data));
  }

  const loadMore = useCallback(() => {
    console.log(loading, loadingUpdate, 'loadMore')
    if (loading || loadingUpdate) {
      return
    }
    params.page = params?.page + 1
    dispatch(fetchListFavoriteRequest(params));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.page, loading, loadingUpdate])

  return { loading, dataList, reLoadList, loadMore, loadingUpdate, lastPage, scrollPosition, params }
}

export function useUpdateFavoriteList() {
  const dispatch = useDispatch();
  const { dataList } = useSelector((state: any) => state.Favorites || {});

  const updateList = (id: number, recipeRequestId?: any) => {

    function removeItemById(list: any, idRemove: any, recipeRequestId?: any) {
      let listAfterRemove = list;
      if (recipeRequestId) {
        listAfterRemove = listAfterRemove.filter(
          (item: any) => item?.id !== idRemove || item?.recipe_request_id !== recipeRequestId
        );
      } else {
        listAfterRemove = listAfterRemove.filter((item: any) => item?.id !== idRemove);
      }
      return listAfterRemove;
    }
    const updatedList = removeItemById(dataList, id, recipeRequestId);
    const listFavoriteMap = { data: updatedList }
    dispatch(updateFavoriteList(listFavoriteMap));
  }

  return { updateList }
}
